module.exports = __webpack_public_path__ + "static/media/gallery8.e4277564.jpg";